import {AnalyticsApi} from 'global/api';
import {CreateRequest} from 'labxchange-client/apis/AnalyticsApi';

/***
 * Create an event with delay if other requests need to be prioritized.
 * @param requestedParams
 */
export function createAnalyticsEventWithDelay(requestedParams: CreateRequest) {
    setTimeout(() => {
        AnalyticsApi.create(requestedParams);
    }, 2500);
}
